import { LabelBadge } from 'components/Badge/LabelBadge'
import { CancelBtn } from 'components/Button/CancelBtn'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { Input } from 'components/Input/Input'
import { NavBar } from 'components/NavBar/NavBar'
import { useState } from 'react'
import { Button, colors, Flex, H1WithBack, ItemsGrid, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { IFatigueRulesFormState } from 'types/fatigueRules.interface'
import { ACTIVE_RULES_FORM, MOCK_FATIGUE_RULES_VERSIONS } from './fatigueRulesData'

const activeVersion = MOCK_FATIGUE_RULES_VERSIONS.find((v) => v.active)

export const FatigueRules = () => {
    const [state, setState] = useState<IFatigueRulesFormState>({ ...ACTIVE_RULES_FORM })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handlePublish = () => null

    return (
        <>
            <NavBar />
            <PageWrapper>
                <H1WithBack title='Fatigue Rules' arrow />
                <Flex gap='1rem' alignStart width='100%' style={{ marginTop: '2rem' }}>
                    <Container style={{ flex: 2 }}>
                        <ContainerHeader padding>
                            <Flex column gap='0.25rem'>
                                <TitleText weight='bold'>Edit rules</TitleText>
                                {activeVersion && (
                                    <OtherText grey>
                                        CURRENTLY ACTIVE {activeVersion.publishedAt} · #{activeVersion.id}
                                    </OtherText>
                                )}
                            </Flex>
                        </ContainerHeader>
                        <ContainerContent gap='1.5rem'>
                            <Flex column gap='1rem'>
                                <TitleText weight='bold'>Working-hour limits</TitleText>
                                <ItemsGrid columns={2} gap='1rem'>
                                    <Input
                                        name='maxConsecutiveHours'
                                        labelText='Max consecutive hours (per shift)'
                                        value={state.maxConsecutiveHours}
                                        onChange={handleChange}
                                    />
                                    <Input
                                        name='maxHoursPer7Days'
                                        labelText='Max hours per 7 days'
                                        value={state.maxHoursPer7Days}
                                        onChange={handleChange}
                                    />
                                </ItemsGrid>
                                <Input
                                    name='minRestBetweenShifts'
                                    labelText='Min rest between shifts (h)'
                                    value={state.minRestBetweenShifts}
                                    onChange={handleChange}
                                />
                            </Flex>

                            <Flex column gap='1rem'>
                                <TitleText weight='bold'>Fatigue index thresholds</TitleText>
                                <ItemsGrid columns={2} gap='1rem'>
                                    <Input
                                        nomarg
                                        name='elevatedAt'
                                        labelText='Elevated at'
                                        value={state.elevatedAt}
                                        onChange={handleChange}
                                    />
                                    <Input
                                        nomarg
                                        name='highAt'
                                        labelText='High at'
                                        value={state.highAt}
                                        onChange={handleChange}
                                    />
                                </ItemsGrid>
                                <Input
                                    nomarg
                                    name='criticalAt'
                                    labelText='Critical at'
                                    value={state.criticalAt}
                                    onChange={handleChange}
                                />
                            </Flex>

                            <Input
                                nomarg
                                name='notes'
                                type='textarea'
                                height='6rem'
                                labelText='Notes (optional)'
                                value={state.notes}
                                onChange={handleChange}
                            />

                            <Flex gap='1rem' justend width='100%'>
                                <CancelBtn />
                                <Button orange width='200px' onClick={handlePublish}>
                                    Publish New Version
                                </Button>
                            </Flex>
                        </ContainerContent>
                    </Container>

                    <Container style={{ flex: 1 }}>
                        <ContainerHeader padding>
                            <TitleText weight='bold'>Version history</TitleText>
                        </ContainerHeader>
                        <ContainerContent gap='1rem'>
                            {MOCK_FATIGUE_RULES_VERSIONS.map((version) => (
                                <Container key={version.id}>
                                    <ContainerHeader padding>
                                        <Flex between width='100%' center>
                                            <BodyText weight='600'>
                                                #{version.id} · {version.publishedAt}
                                            </BodyText>
                                            {version.active && (
                                                <LabelBadge
                                                    color={colors.orange}
                                                    backgroundColor={colors.paleOrange}
                                                >
                                                    ACTIVE
                                                </LabelBadge>
                                            )}
                                        </Flex>
                                    </ContainerHeader>
                                    <ContainerContent gap='0.5rem'>
                                        <OtherText grey>{version.summary}</OtherText>
                                        <OtherText>{version.note}</OtherText>
                                    </ContainerContent>
                                </Container>
                            ))}
                        </ContainerContent>
                    </Container>
                </Flex>
            </PageWrapper>
        </>
    )
}
